module.exports = __webpack_public_path__ + "img/eg-16-01.65ac4a68.jpg";